// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__o-zYg","link":"style_link__7qW1L","links_wrapper":"style_links_wrapper__hwZta","git_logo":"style_git_logo__wcm0X"};